// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Iu-z","tooltipWrapper":"Ju-z","icon":"Ku-z","tooltip":"Lu-z","content":"Mu-z"};